import React, { useState } from 'react';
import { VbzModal, VbzDivider, Button } from '@smiles/voebiz-ui-kit';
import ModalBody from 'reactstrap/lib/ModalBody';
import { isMobile } from 'react-device-detect';
import { Col, Container, Row, Card, CardHeader, CardBody, Collapse } from 'reactstrap';
import { useTranslation } from 'react-i18next';

interface Props {
  isOpen: boolean;
  toggleModal(isOpen: boolean): void;
  onClick: () => void;
  component: string;
  isLoading?: boolean;
  buttonText?: 'btn_confirm' | 'btn_delete';
}

const ModalRemovePlan: React.FC<Props> = ({
  isOpen = false,
  toggleModal,
  onClick,
  component,
  isLoading,
  buttonText = 'btn_confirm',
}) => {
  const { t } = useTranslation(component);
  const [buttonRemove, setButtonRemove] = useState(false);
  const texts = t('list_text', { returnObjects: true }) as Array<string>;

  const [toggleQuestion, setToggequestion] = useState(1);

  const openCard = () => {
    if (toggleQuestion === 1) {
      setToggequestion(2);
    } else {
      setToggequestion(1);
    }
  };

  const removePlans = async () => {
    setButtonRemove(true);
    await onClick();
    toggleModal(false);
    setButtonRemove(false);
  };

  return (
    <VbzModal
      isOpen={isOpen}
      type="right"
      toggle={() => {
        toggleModal(false);
      }}
      backButton={!isMobile}
      closedButton={isMobile}
    >
      <ModalBody>
        <Container>
          <Row className="d-block">
            <Col className="modal-remove-plan">
              <div className="modal-remove-plan-baggage" />
              <h1>{t('title')}</h1>
              <p>{t('subtitle')}</p>
              <Card>
                <div className="d-flex w-100">
                  <CardHeader>{t('card_title')}</CardHeader>
                  <div
                    className={toggleQuestion === 1 ? 'arrow-modal-remove' : 'arrow-up-modal-remove'}
                    onClick={() => openCard()}
                    data-testid="arrow-icon-testid"
                  />
                </div>
                <Collapse isOpen={toggleQuestion !== 1}>
                  <CardBody>
                    <div>
                      <VbzDivider />
                    </div>
                    <div>
                      <span>{t('card_subtitle')}</span>
                    </div>
                    <ol>
                      {texts?.map((text) => (
                        <li key={text}>{text}</li>
                      ))}
                    </ol>
                  </CardBody>
                </Collapse>
              </Card>
              <Button onClick={() => removePlans()} className="mt-5" disabled={buttonRemove || isLoading}>
                <span data-testid="confirm-btn-testid">{t(buttonText)}</span>
              </Button>
              <div data-testid="tooglemodal-false" className="mt-3" onClick={() => toggleModal(false)}>
                <span style={{ position: 'relative', top: '8px', cursor: 'pointer' }}>{t('link_back')}</span>
                <hr
                  style={{ width: '42px', border: '1px solid #999999', borderRadius: '100px', position: 'absolute' }}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </ModalBody>
    </VbzModal>
  );
};

export default ModalRemovePlan;
